import { lazy, useState } from 'react';
import { Suspense } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useLazyComponentPreload } from '@medifind/hooks';
import { IconShareSmall } from '@medifind/icons';
import { Button } from '@medifind/shared-basic-components';
import { useMediaQueryDown } from '@medifind/utils';
const ShareModal = lazy(() => import('./ShareModal'));

const Share = (props) => {
  useLazyComponentPreload(ShareModal, 20000);
  const [show, setShow] = useState(false);
  const {
    className,
    iconOnly = false,
    color,
    id = 'share-button',
    style,
    buttonText = 'Share',
    noButton = false,
    buttonType,
    isListItem,
    iconOnlyAt,
    onClick,
    onModalClose,
    classes,
  } = props;

  const isMobileXS = useMediaQueryDown(iconOnlyAt ?? 'xs');

  let iconColor = 'blue';
  if (color === 'darkBlue') {
    iconColor = 'darkBlue';
  } else if (color === 'transparent') {
    iconColor = 'blue';
  } else if (color === 'transparent-blue') {
    iconColor = 'blue';
  } else if (color === 'blue') {
    iconColor = 'blue';
  } else if (color === 'light-blue') {
    iconColor = 'light-blue';
  }
  return (
    <>
      <Button
        onClick={(event) => {
          onClick && onClick();
          setShow(true);
          event.preventDefault();
          event.stopPropagation();
        }}
        noPadding={!!isListItem}
        color={color ? color : isListItem ? 'none' : iconOnly ? 'transparent' : 'light-blue'}
        style={style}
        iconOnlyAt={iconOnlyAt}
        type={buttonType}
        className={classNames(className)}
        id={id}
        noButton={noButton}
        focus={iconOnly ? 'background' : 'underline'}
        screenReaderText="Share"
        label={!iconOnly ? buttonText : null}
        iconBefore={
          <IconShareSmall color={iconColor} width={isMobileXS && iconOnlyAt ? 16 : 12} height={isMobileXS && iconOnlyAt ? 21 : 15} />
        }
        classes={classes}
      />
      {show && (
        <Suspense fallback={<div className="fallback" />}>
          <ShareModal
            {...props}
            onModalClose={() => {
              setShow(false);
              onModalClose && onModalClose();
            }}
          />
        </Suspense>
      )}
    </>
  );
};
Share.propTypes = {
  onClick: PropTypes.func,
  buttonType: PropTypes.string,
  isListItem: PropTypes.bool,
  iconOnlyAt: PropTypes.string,
  noButton: PropTypes.bool,
  iconOnly: PropTypes.bool,
  color: PropTypes.string,
  buttonText: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  onModalClose: PropTypes.func,
};

export { Share as default, Share };
